<script setup lang="ts">
definePageMeta({
  name: 'ct.login',
  layout: 'auth',
})

const { user, logout, isAuthenticated } = useUser()

const route = useRoute()
const isLoading = ref(false)

const errorMessage = computed(() => {
  const error = route.query.error
  if (typeof error !== 'string' || !error || error === 'microsoft') return null
  return error
})

const oauthError = computed(() => route.query.error === 'microsoft' || !!errorMessage.value)

async function handleLogout() {
  await logout()
  await navigateTo('/login')
}

function loginWithMicrosoft() {
  isLoading.value = true
  // Full navigation to the OAuth start route (server-side).
  window.location.href = '/auth/microsoft'
}
</script>

<template>
  <div v-if="isAuthenticated" class="flex flex-col items-center gap-4 min-w-[300px]">
    <UAlert
      color="neutral"
      variant="soft"
      icon="lucide:log-out"
      :title="`Ingelogd als ${user?.email || ''}`"
    />
    <UButton
      block
      color="neutral"
      variant="soft"
      @click="handleLogout"
    >
      Uitloggen
    </UButton>
  </div>

  <UCard v-else class="min-w-[300px]">
    <div class="flex flex-col gap-4">
      <UAlert
        v-if="oauthError"
        color="error"
        variant="soft"
        icon="lucide:alert-circle"
        title="Microsoft-login mislukt"
        :description="errorMessage || 'Probeer het opnieuw. Controleer of de app-registratie en redirect-URL kloppen.'"
      />

      <UButton
        block
        color="primary"
        size="lg"
        icon="simple-icons:microsoft"
        :loading="isLoading"
        :disabled="isLoading"
        @click="loginWithMicrosoft"
      >
        Inloggen met Microsoft
      </UButton>
    </div>
  </UCard>
</template>
